import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CKEditor from 'ckeditor4-react';//ckeditor4-react//react-ckeditor-component
import './ParadigmaCKEditor.css';

class ParadigmaCKEditor extends Component{

	static propTypes = {
		maxLength : PropTypes.int,
		readOnly: PropTypes.bool,
		onChange: PropTypes.func,
		onValueChange: PropTypes.func,
		config: PropTypes.object,
		value: PropTypes.string.isRequired,
		name: PropTypes.string,
		isInForm:PropTypes.bool.isRequired,
		filebrowserImageUploadUrl: PropTypes.string,
		fileTools_requestHeaders: PropTypes.string,
	}

	constructor(props) {
		super(props);

		this.value = props.value === undefined ? "" : props.value;
		this.UniqueInvoked = false;

		this.config = props.config !== undefined ? props.config : {
			toolbarGroups:
			[
				{ name: 'tools' },
				{ name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
				{ name: 'editing', groups: [ 'find', 'selection', 'spellchecker' ] },
				{ name: 'links' },
				{ name: 'insert' },
				{ name: 'document', groups: [ 'document', 'doctools' ] },
				{ name: 'others' },
				{ name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
				{ name: 'paragraph',   groups: [ 'list', 'indent', 'blocks', 'align', 'bidi' ] },
				{ name: 'styles' },
				{ name: 'colors' }
			],
			extraPlugins : 'filebrowser, justify',
			filebrowserImageUploadUrl : props.filebrowserImageUploadUrl,
			fileTools_requestHeaders : props.fileTools_requestHeaders,
		};

		this.editorRef = React.createRef();

		this.handleChange = this.handleChange.bind(this);
		this.handleValueChange = this.handleValueChange.bind(this);
		this.handleFileUploadResponse = this.handleFileUploadResponse.bind(this);

	}

	getLength(){
		return this.value !== undefined ? this.value.length : 0;
	}

	killEditor(){
		if(this.editorRef.current != null && this.editorRef.current.editor != null){
			let editor = this.editorRef.current.editor;
			editor.destroy(true);
		}
	}

	handleChange = evt => {
		this.handleValueChange(evt);
		if (this.props.onChange){
			this.props.onChange(evt);
		}
	}

	handleValueChange = evt => {
		this.updateValue(evt.editor.getData());
		if (this.props.onValueChange){
			this.props.onValueChange(evt.editor.getData());
		}
	}

	handleFileUploadResponse(evt){
		let that = this;
		setTimeout(function(){
			if(that.editorRef.current != null && that.editorRef.current.editor != null){
				let editor = that.editorRef.current.editor;
				let content = editor.getData();
				editor.fire('change', content);
			}
		}, 500);
	}

	updateValue(val){
		this.value = val;
	}

	uniqueUpdateUsingTimeOut(){
		if(this.UniqueInvoked == false){
			let that = this;
			setTimeout(function(){
				if(that.editorRef.current != null && that.editorRef.current.editor != null){
					let editor = that.editorRef.current.editor;
					if(editor.getData() !== that.value){
						editor.setData(that.value);
					}
				}
			}, 150);
			this.UniqueInvoked = true;
		}
	}

	componentWillReceiveProps(nextProps){
		this.uniqueUpdateUsingTimeOut();
		let result = false;
		let propsUndefined = nextProps == undefined || nextProps == null;
		let nextPropsValueNotUndefined = nextProps.value !== undefined;
		if(propsUndefined == false && nextPropsValueNotUndefined){
			this.updateValue(nextProps.value);
			result = true;
		}
		return result;
	}

	onValidation(){
		let lengthAllowed = this.props.maxLength !== undefined ? this.props.maxLength : 5000;
		let result = this.value !== undefined && this.value.length < lengthAllowed;
		return result;
	}

	render(){
		return (
			<div>
			{this.props.isInForm == true && <input name={this.props.name} type="hidden" value={this.value} />}
			<CKEditor
			data={this.value}
			readOnly={this.props.readOnly === undefined ? true : this.props.readOnly}
			config={this.config}
			onChange={this.handleChange}
			onFileUploadResponse={this.handleFileUploadResponse}
			activeClass="editor"
			ref={this.editorRef}
			/>
			{
				this.onValidation() == false && false &&
				<p class="h6 text-danger">Longitud Maxima superada</p>
			}
			</div>
		);
	}
}
export default ParadigmaCKEditor;



// WEBPACK FOOTER //
// ./src/components/paradigmaCKEditor/ParadigmaCKEditor.js